import React, { useState, useEffect, useMemo } from "react";
import { Message, } from "semantic-ui-react";
import { TLoadable, createUnloaded, isUnloaded, isLoaded, createLoaded, isLoadErrored } from "../../../sg-core";
import { useLoginStatus, useAnonPackage, selectToken } from "../auth/store/authSelectors";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { PageTemplate } from "../components/PageTemplate/PageTemplate";
import { IObservationPackage } from "../interfaces/ObservationPackage/ObservationPackage";
import { createRequestFetchInitalAppContext } from "../store/actions/contextActions";
import ObservationPrint from "../components/observation/ObservationPrint/ObservationPrint";


const getTextProps = (t: TFunction) => ({
    loadErrorText: t("Havainnon avaaminen epäonnistui")
});


interface IObservationPrintPage extends ReturnType<typeof getTextProps> { data: IObservationPackage; }

const ObservationPrintPage: React.FC<IObservationPrintPage> = ({ data }) => {
    const observation = data.observation
    return (
        <PageTemplate>
            <ObservationPrint
                observation={observation}
                category={data.category}
            />
        </PageTemplate>

    );
};

const MemoizedObservationPrintPage = React.memo(ObservationPrintPage);

const ObservationPrintPageContainer: React.FC = () => {
    const loginStatus = useLoginStatus();
    const dispatch = useDispatch();

    const { t } = useTranslation();
    const textProps = useMemo(() => getTextProps(t), [t]);

    const [observationId, setObservationId] = useState<TLoadable<IObservationPackage>>(createUnloaded());

    const anonPackage = useAnonPackage();
    const token = useSelector(selectToken)


    useEffect(() => {
        if (isUnloaded(observationId) && anonPackage?.observation) {
            setObservationId(createLoaded(anonPackage));
            dispatch(createRequestFetchInitalAppContext());
        }
    }, [observationId, anonPackage, loginStatus]);


    if (isLoadErrored(observationId)) {
        return (<Message negative> {textProps.loadErrorText} </Message>);
    }

    if (!isLoaded(observationId) || !isLoaded(loginStatus)) {
        return (
            <div>Ladataan...</div>
        )
    }


    return <MemoizedObservationPrintPage {...textProps} data={observationId.data} />;
};

export default ObservationPrintPageContainer;
